var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConteudosInovar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.7 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.2,42.6c1.6-4.1,3.5-8.2,5.7-12.1,5.6-9.1,2.7-21-6.4-26.6C21.4-1.7,9.5,1.1,3.9,10.3,0,16.7,0,24.8,4.2,31.1c2,3.5,3.7,7.2,5.2,10.9.7,2.2,1.2,4.5,1.2,6.9,0,1.2.4,2.4,1.1,3.4l.5.8c1.2,1.8,3.2,2.8,5.3,2.8h5.9c2.3-.4,4.8-1.4,5.8-3.7h0M14.9,7.9s-8.4,3.5-8.4,10,4,13.8,4,13.8c0,0,4.6,6.5,4.6,10s.5,7.6,2.7,8.6c1.9.8,4,.8,5.9,0,.3-.2.7-.5,1-.8,1.6-1.5,3.8-2.2,5.9-1.7s1.7.8,2.1,1.6c.6,1.2,1.1,3.1-.6,4.9,0,0-.1.1-.2.2-2.5,2.7-5.7,4.9-9.3,5.6l-11.2,1.5s-1.6,3.3,1.1,3.7c4.6.7,15.1-2.2,15.1-2.2,0,0,2.7,1.6-.5,3.3s-14.6,2.7-14.6,2.7c0,0-.5,3.8,3.8,3.8,2.4,0,4.9-.2,7.3-.5M50.4,21v12.3M56.5,27.1h-12.3M55.5,9.6v12.3M61.7,15.7h-12.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConteudosInovar);
export default __webpack_public_path__ + "static/media/conteudos-inovar.5d1faa601ff214a3c90a26bf3d5b38b3.svg";
export { ForwardRef as ReactComponent };